// extracted by mini-css-extract-plugin
module.exports = {"table":"ServicesPrices-module--table--1GWaL","button":"ServicesPrices-module--button--3QIB7","list":"ServicesPrices-module--list--3Mhik"};